export const PATH_TO_REDIRECT = 'pathToRedirect';
export const PRICE = 'price';
export const DOWN_PAYMENT = 'downPayment';
export const YEAR_SELECTED = 'yearSelected';
export const BRAND_SELECTED = 'brandSelected';
export const MODEL_SELECTED = 'modelSelected';
export const VERSION_SELECTED = 'versionSelected';
export const POSTAL_CODE = 'postalCode';
export const ID_VEHICLE = 'idVehicle';
export const GROUP_NAME = 'groupName';
export const GROUP_ID = 'groupId';
export const GROUP_LOCATION = 'groupLocation';
export const HAS_INSURANCE = 'hasInsurance';
export const UTM_SOURCE = 'utmSource';
export const UTM_MEDIUM = 'utmMedium';
export const UTM_CAMPAIGN = 'utmCampaign';
export const UTM_TERM = 'utmTerm';
export const UTM_CONTENT = 'utmContent';
export const GCLID = 'gclid';
export const VEHICLE_PREMIUM_INFO = 'vpi';
export const ORIGINAL_PHOTO = 'originalPhoto';
export const THUMBNAIL_PHOTO = 'thumbnailPhoto';

export const CALCULATOR_COOKIES: string[] = [
    PRICE, DOWN_PAYMENT, HAS_INSURANCE, BRAND_SELECTED, MODEL_SELECTED, VERSION_SELECTED, YEAR_SELECTED,
    VEHICLE_PREMIUM_INFO, POSTAL_CODE, ID_VEHICLE, GROUP_NAME, GROUP_ID, GROUP_LOCATION, HAS_INSURANCE, UTM_SOURCE,
    UTM_MEDIUM, UTM_CAMPAIGN, UTM_TERM, UTM_CONTENT, GCLID, ORIGINAL_PHOTO, THUMBNAIL_PHOTO
];